// extracted by mini-css-extract-plugin
export default {"main":"Login_main__wZIcG","login_card":"Login_login_card__x-Ica"};